<template>
  <div class="orderList">
    <!-- <header>
      <div class="order-header">
        <van-icon name="arrow-left" class="i" @click="goback"/>
        <span>订单列表</span>
      </div>
    </header>-->
    <!-- 头部 -->
    <hearderCommon :text="text"></hearderCommon>

    <van-tabs v-model="active" class="ty-tabs">
      <van-tab v-for="index in tabList" :key="index.name" :title="index.name" :to="index.path"></van-tab>
    </van-tabs>
    <router-view @list="list" @Active="Active"></router-view>
    <van-loading type="spinner" color="rgb(116, 180, 43)" class="loading" v-if="loading" />
    <div v-if="noSearchList">
      <img src="../assets/无订单.png" alt class="noList" />
      <p class="search-p">暂无订单</p>
    </div>
  </div>
</template>

<script>
import hearderCommon from "./common/headerCommon";

export default {
  data() {
    return {
      active: 0,
      tabList: [
        { name: "待发货", path: "send" },
        { name: "待收货", path: "harvested" },
        { name: "待对账", path: "reconciliation" },
        { name: "交易成功", path: "succeed" },
        { name: "交易关闭", path: "defeated" }
      ],
      noSearchList: true,
      orderList: [],
      loading: true,
      text: "订单列表"
    };
  },
  methods: {
    fn(path) {
      this.$router.push(path);
    },
    // 订单为空显示
    async list(list) {
      this.orderList = list;
      this.loading = false;
      if (list.length === 0) {
        this.noSearchList = true;
      } else {
        this.noSearchList = false;
      }
    },
    Active(Active) {
      this.loading = true;
      this.noSearchList = false;
      this.active = Active;
    },
    goback() {
      this.$router.push("/my");
    }
  },
  components: {
    hearderCommon
  }
};
</script>

<style scoped>
.orderList {
  background: rgba(242, 242, 242, 1);
  height: 89%;
  padding-top: 21%;
}
header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.ty-tabs {
  font-weight: 700;
  position: fixed;
  top: 36px;
  width: 100%;
  left: 0;
  z-index: 9999;
}
.i {
  margin: 10px;
  margin-right: 5px;
}
.noList {
  width: 100%;
  height: 100%;
  margin-top: 100px;
  vertical-align: middle;
  object-fit: cover;
}
.search-p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
}
.order-header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgba(237, 237, 237, 1);
  z-index: 9999;
}
.orderList >>> .van-tabs__line {
  background-color: #74b42b !important;
}
.orderList >>> .van-tab--active {
  background-color: rgba(249, 249, 249, 1);
  border-bottom: 4px solid #74b42b !important;
  font-weight: 700;
}
.van-icon-arrow-left {
  top: 2px;
}
.loading { 
  position: fixed;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
}
</style>